import { createContext, type PropsWithChildren, useCallback, useMemo } from 'react'

interface MessagingBusPayload {
	type: string
	value: any
}

interface MessagingBusContextData {
	broadcast: (type: string, value: any) => void
}

export const MessagingBusContext = createContext<MessagingBusContextData>({
	broadcast: () => {},
})

export default function MessagingBusProvider({ children }: PropsWithChildren) {
	const busInstance = useMemo(() => new BroadcastChannel('_wll_tabs'), [])

	busInstance.onmessage = useCallback((e: MessageEvent<MessagingBusPayload>) => {
		const { type } = e.data

		switch (type) {
			case 'SWITCH_TENANT':
			case 'UPDATE_TENANT':
			case 'LOGOUT':
				window.location.reload()
				break
		}
	}, [])

	const broadcast: MessagingBusContextData['broadcast'] = (type, value) => busInstance.postMessage({ type, value })

	return <MessagingBusContext.Provider value={{ broadcast }}>{children}</MessagingBusContext.Provider>
}
